import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  count: 0,
  loading: false,
  error: null,
  initialized: false  // Add initialization flag
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    fetchWishlistStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchWishlistSuccess(state, action) {
      const items = Array.isArray(action.payload) ? action.payload : [];
      state.items = items;
      state.count = items.length;
      state.loading = false;
      state.initialized = true;  // Mark as initialized
    },
    fetchWishlistFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.initialized = true;  // Mark as initialized even on failure
    },
    addToWishlist(state, action) {
      // Check if item already exists
      const exists = state.items.some(item => 
        item.productId._id === action.payload.productId._id && 
        item.variantId === action.payload.variantId
      );
      if (!exists) {
        state.items.push(action.payload);
        state.count += 1;
      }
    },
    // wishlistSlice.js
removeFromWishlist(state, action) {
  state.items = state.items.filter(item => 
    !(item.productId._id === action.payload.productId && 
      item.variantId === action.payload.variantId)
  );
  state.count = state.items.length;
},
    // removeFromWishlist(state, action) {
    //   state.items = state.items.filter(item => 
    //     !(item.productId._id === action.payload.productId && 
    //       item.variantId === action.payload.variantId)
    //   );
    //   state.count = state.items.length;
    // },
    // addToWishlist(state, action) {
    //   state.items.push(action.payload);
    //   state.count += 1;
    // },
    // removeFromWishlist(state, action) {
    //   state.items = state.items.filter(item => item.productId._id !== action.payload);
    //   state.count -= 1;
    // },
    clearWishlist(state) {
      state.items = [];
      state.count = 0;
    }
  }
});

export const {
  fetchWishlistStart,
  fetchWishlistSuccess,
  fetchWishlistFailure,
  addToWishlist,
  removeFromWishlist,
  clearWishlist
} = wishlistSlice.actions;

export default wishlistSlice.reducer;

// // src/redux/slices/wishlistSlice.js
// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   items: [],  // Now storing full product objects
//   count: 0,
//   loading: false,
//   error: null
// };

// const wishlistSlice = createSlice({
//   name: 'wishlist',
//   initialState,
//   reducers: {
//     fetchWishlistStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     fetchWishlistSuccess(state, action) {
//       const items = Array.isArray(action.payload) ? action.payload : [];
//       state.items = action.payload;
//       state.count = action.payload.length;
//       state.loading = false;
//     },
//     fetchWishlistFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     addToWishlist(state, action) {
//       state.items.push(action.payload);
//       state.count += 1;
//     },
//     removeFromWishlist(state, action) {
//       // Update to filter by product ID
//       state.items = state.items.filter(item => item.productId._id !== action.payload);
//       state.count -= 1;
      
//     },
//     clearWishlist(state) {
//       state.items = [];
//       state.count = 0;
//     }
//   }
// });

// export const {
//   fetchWishlistStart,
//   fetchWishlistSuccess,
//   fetchWishlistFailure,
//   addToWishlist,
//   removeFromWishlist,
//   clearWishlist
// } = wishlistSlice.actions;

// export default wishlistSlice.reducer;

// // src/redux/slices/wishlistSlice.js
// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   items: [],
//   count: 0,
//   loading: false,
//   error: null
// };

// const wishlistSlice = createSlice({
//   name: 'wishlist',
//   initialState,
//   reducers: {
//     fetchWishlistStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     fetchWishlistSuccess(state, action) {
//       state.items = action.payload;
//       state.count = action.payload.length;
//       state.loading = false;
//     },
//     fetchWishlistFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     addToWishlist(state, action) {
//       state.items.push(action.payload);
//       state.count += 1;
//     },
//     removeFromWishlist(state, action) {
//   state.items = state.items.filter(item => item.productId !== action.payload);
//   state.count -= 1;
// },
//     clearWishlist(state) {
//       state.items = [];
//       state.count = 0;
//     }
//   }
// });

// export const {
//   fetchWishlistStart,
//   fetchWishlistSuccess,
//   fetchWishlistFailure,
//   addToWishlist,
//   removeFromWishlist,
//   clearWishlist
// } = wishlistSlice.actions;

// export default wishlistSlice.reducer;